/** @jsxImportSource @emotion/react */

import Column from "../../../../components/Grid/Column";
import Row from "../../../../components/Grid/Row";
import useDocumentDetails from "../../../../hooks/useDocumentDetails";
import SelectProvider from "../components/SelectProvider";
import CostsTable from "../../DocumentDetails/components/CostsTable";
import { Result } from "../../../../graphql/__GENERATED__/types";
import { FC, useEffect, useMemo } from "react";
import ApproveQuotation from "../components/ApproveQuotation";

const Costs: FC = () => {
  const {
    selectedResultId,
    setSelectedResultId,
    documentData: { selectedSimulationResults },
  } = useDocumentDetails();

  const selectResult = (resultId: string) => {
    setSelectedResultId(resultId);
  };

  const selectedResult = useMemo(() => {
    return selectedSimulationResults?.find(
      (result) => result?._id === selectedResultId
    );
  }, [selectedResultId]);

  useEffect(() => {
    if (!selectedResultId) {
      setSelectedResultId(selectedSimulationResults![0]?._id!);
    }
  }, [selectedSimulationResults]);

  return (
    <>
      <Row justify="between">
        <Column xs={12} xl={6.5}>
          <SelectProvider onClick={selectResult} />
        </Column>
        <Column xs={12} lg={8} xl={4.5}>
          <CostsTable selectedResult={selectedResult as Result} />
        </Column>
      </Row>
      <ApproveQuotation />
    </>
  );
};

export default Costs;
